export default __webpack_public_path__ + "static/media/addEskem.67313f37.ico";